import { Link } from 'react-router-dom';
import { articles } from '@/mocks/anime';

export default function HotRecommend() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-400">
              精选本周必看国产动漫深度解析
            </p>
          </div>
          <Link
            to="/category/rexue-zhandou"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-400"
                  style={{ backgroundImage: `url(${article.coverImage})` }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
                    {article.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-50/90 rounded-md">
                  <i className="ri-star-fill text-xs text-secondary-500"></i>
                  <span className="text-xs font-medium text-foreground-100">{article.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/rexue-zhandou"
            className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}